module.exports = __webpack_public_path__ + "img/15.092e395d.jpg";